import controller from './kform-toolbar.controller';
import template from './kform-toolbar.html';
import './kform-toolbar.scss';

export default {
	controller,
	template,
	bindings: {
		kid: '<',
	},
	require:  {
		kform: '^^kform',
		listPreview:  '^^?listPreview',
	},
};
